import React, { Component } from 'react';
import axios from 'axios';

import { CustomNav } from '../Components/CustomNav';
import { apiServerUrl } from '../config';
import { authHeader, requestOptions } from '../_helpers';
import Dropzone from 'react-dropzone';
import { VideoWrapper } from '../Components/VideoWrapper';

export class Video extends Component {
  constructor(props) {
    super(props);
    this.state = {
      players: [
        { name: 'Connor Mcdavid', player_id: '361' },
        { name: 'Johnny Gaudreau', player_id: '771' },
        { name: 'Liam Foudy', player_id: '1952' }
      ],
      files: [],
      videos: [],
      selectedVideo: ''
    };
    this.submitVideos = this.submitVideos.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.changePlayer = this.changePlayer.bind(this);
    this.playVideo = this.playVideo.bind(this);
    this.hideVideo = this.hideVideo.bind(this);
  }

  hideVideo(video) {
    let currentComponent = this;
    currentComponent.setState({
      selectedVideo: ''
    });
  }
  playVideo(video, index) {
    let currentComponent = this;
    console.log('playing video');
    console.log(video);
    console.log(index);
    currentComponent.setState({
      selectedVideo: video
    });
  }

  changePlayer(e) {
    console.log(e.target.value);
    let currentComponent = this;
    //Call out and get videos
    axios
      .get(
        apiServerUrl + '/player_videos?player_id=' + e.target.value,
        requestOptions()
      )
      .then(function(response) {
        console.log(response.data);
        currentComponent.setState({
          videos: response.data
        });
      });

    /*let currentComponent = this;
    currentComponent.setState({
      //files: acceptedFiles,
      videos: [
        {
          video_id: '1',
          description: 'Connor Mcdavid Highlights',
          uploaded_by: '1',
          player_id: '361'
        },
        {
          video_id: '1',
          description: 'Connor Mcdavid Highlights',
          uploaded_by: '1',
          player_id: '361'
        }
      ]
    });*/
  }
  submitVideos() {
    console.log('submit videos');
    //Save the Videos
    this.state.files.forEach(file => {
      //req.attach(file.name, file);
    });
  }
  onDrop(acceptedFiles, rejectedFiles) {
    let currentComponent = this;
    console.log('files');
    console.log(acceptedFiles);
    currentComponent.setState({
      files: acceptedFiles,
      test: true
    });
    console.log('i set state');
  }

  render() {
    console.log(this.state.files);
    console.log(this.state.players);
    console.log(this.state.players[0]);
    this.state.players.map(item => console.log(item.name));
    return (
      <div>
        <header className="nav">
          <CustomNav />
        </header>
        <div style={{ marginLeft: '50px' }}>
          <h2 style={{ color: 'grey' }}>Pick Your Player</h2>
          <select
            className="teamList"
            style={{ alignSelf: 'flex-start' }}
            onChange={e => this.changePlayer(e)}
          >
            <option key={'default'}>CHOOSE PLAYER</option>
            {this.state.players.map(item => (
              <option key={item.player_id} value={item.player_id}>
                {item.name}
              </option>
            ))}
          </select>

          <div style={{ display: 'flex', flexDirection: 'space-evenly' }}>
            <div style={{ flex: 1 }}>
              <h2 style={{ color: 'grey' }}>Upload Videos</h2>

              <div style={{ paddingBottom: '20px' }}>
                <Dropzone onDrop={this.onDrop}>
                  <p style={{ textAlign: 'center' }}>
                    Drop files here, or click to select files to upload.
                  </p>
                </Dropzone>
                {this.state.files.length > 0 ? (
                  <div>
                    <h2 style={{ color: 'white' }}>
                      Uploading {this.state.files.length} files...
                    </h2>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '200px'
                      }}
                    >
                      {this.state.files.map(file => (
                        <div style={{ paddingRight: '10px' }}>
                          <img src={file.preview} />{' '}
                          <div style={{ fontSize: '20px', color: 'white' }}>
                            {file.name}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : null}
              </div>
              <button
                type="submit"
                style={{ color: 'black' }}
                onClick={this.submitVideos}
              >
                Submit
              </button>
            </div>
            <div style={{ flex: 1 }}>
              <h1 style={{ color: 'grey' }}>
                Current Videos
                {this.state.selectedVideo && (
                  <span style={{ color: 'black', paddingLeft: '15px' }}>
                    <button
                      type="submit"
                      style={{ color: 'black' }}
                      onClick={this.hideVideo}
                    >
                      Hide
                    </button>
                  </span>
                )}
              </h1>
              {this.state.videos.length > 0 &&
                this.state.selectedVideo && (
                  <VideoWrapper selectedVideo={this.state.selectedVideo} />
                )}

              {this.state.videos.length > 0 &&
                this.state.videos.map((video, index) => (
                  <div style={{ paddingRight: '10px' }}>
                    <div
                      style={{ fontSize: '20px', color: 'white' }}
                      onClick={() => this.playVideo(video, index)}
                    >
                      {video.description}-{video.uploaded_by}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Video;



// WEBPACK FOOTER //
// ./src/Pages/Video.js